import { useSelector } from 'react-redux';

const selector = (state) => state.authentication.userInfo.AllowHousingStock;

export const useAllowHousingStock = () => useSelector(selector);
